import { createFileRoute } from '@tanstack/react-router';
import { PushNotificationsManager } from '../../components/admin/PushNotificationsManager';

export const Route = createFileRoute('/admin/push-notifications')({
  component: PushNotificationsTab,
});

function PushNotificationsTab() {
  return <PushNotificationsManager />;
}
